export default function QuickActions() {
  const actions = [
    {
      label: 'Générer message',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 2L12 7L17 9L12 11L10 16L8 11L3 9L8 7L10 2Z" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      ),
    },
    {
      label: 'Rechercher',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M18 18L14 14M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9Z" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      ),
    },
    {
      label: 'Nouvelle campagne',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      ),
    },
    {
      label: 'Créer séquence',
      icon: (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M3 4H17V8H3V4Z" stroke="currentColor" strokeWidth="1.5" />
          <path d="M3 11H17V15H3V11Z" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      ),
    },
  ]

  return (
    <div className="actions-card">
      <div className="card-header">
        <h2>Actions rapides</h2>
      </div>
      <div className="actions-grid">
        {actions.map((action, i) => (
          <button key={i} className="action-btn-modern">
            <div className="action-icon">{action.icon}</div>
            <span>{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
